import React from 'react'
import PropTypes from 'prop-types'
import { AccountType, ContactType, MembershipType } from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import useAuth from 'components/auth/useAuth'
import { NewMemberContactInfo } from '../components'
import { EditMemberContactInfo } from 'member-portal/components'
import { selectors as memberSelectors } from 'member-reducer'
import { selectors as membershipsSelectors } from 'memberships/reducer'
import * as apiActions from 'api-actions'
import * as memberActions from 'member-actions'
import { makeMemberApplicationApplyPath, PATH } from 'config'

const propTypes = {
  initialAccount: AccountType,
  initialContact: ContactType,
  applicationContactId: PropTypes.string,
  applicationMembershipId: PropTypes.string,
  autoCompleteAddress: PropTypes.func.isRequired,
  clearShoppingCart: PropTypes.func.isRequired,
  createMembershipApplicationAccount: PropTypes.func.isRequired,
  fetchPlaceDetails: PropTypes.func.isRequired,
  prefillAccount: AccountType,
  prefillContact: ContactType,
  prefillMembership: MembershipType,
  selectedTrailerCareType: PropTypes.string,
  shoppingCartMembershipType: PropTypes.string,
  updateMembershipApplicationAccount: PropTypes.func.isRequired,
  lookupExistingContact: PropTypes.func.isRequired,
}

function MemberContactInfo({
  initialAccount = null,
  initialContact = null,
  applicationContactId = null,
  applicationMembershipId = null,
  autoCompleteAddress,
  clearShoppingCart,
  createMembershipApplicationAccount,
  fetchPlaceDetails,
  lookupExistingContact,
  prefillAccount = null,
  prefillContact = null,
  prefillMembership = null,
  selectedTrailerCareType = null,
  shoppingCartMembershipType = null,
  updateMembershipApplicationAccount,
}) {
  const { isAuthenticated } = useAuth()
  const isEditing = !!(initialAccount && initialContact)
  const successPath = makeMemberApplicationApplyPath(PATH.BOATS)

  if (isEditing)
    return (
      <EditMemberContactInfo
        {...{
          initialAccount,
          initialContact,
          applicationContactId,
          applicationMembershipId,
          autoCompleteAddress,
          // Locks email + enables Auth0 resume. Renewal omits this so SF
          // contact email is not overwritten by user.email.
          disableEmail: isAuthenticated,
          fetchPlaceDetails,
          successPath,
          updateMembershipApplicationAccount,
          // Package selection + dashboard prefill stay available after Auth0
          // resume (email-only matches withhold lookup IDs until login).
          selectedTrailerCareType,
          shoppingCartMembershipType,
          prefillAccount,
          prefillContact,
          prefillMembership,
          // Guest join only: same lookup + modal outcomes as first Contact
          // submit. Authenticated / renewal omit these.
          ...(!isAuthenticated && {
            clearShoppingCart,
            lookupExistingContact,
          }),
        }}
      />
    )

  return (
    <NewMemberContactInfo
      {...{
        autoCompleteAddress,
        clearShoppingCart,
        createMembershipApplicationAccount,
        fetchPlaceDetails,
        lookupExistingContact,
        prefillAccount,
        prefillContact,
        prefillMembership,
        selectedTrailerCareType,
        shoppingCartMembershipType,
        successPath,
        updateMembershipApplicationAccount,
      }}
    />
  )
}

MemberContactInfo.propTypes = propTypes

function mapStateToProps(state) {
  return {
    initialAccount: memberSelectors.account(state),
    initialContact: memberSelectors.contact(state),
    applicationMembershipId: memberSelectors.applicationMembershipId(state),
    applicationContactId: memberSelectors.applicationContactId(state),
    prefillAccount: membershipsSelectors.applicationPrefillAccount(state),
    prefillContact: membershipsSelectors.applicationPrefillContact(state),
    prefillMembership: membershipsSelectors.applicationPrefillMembership(state),
    selectedTrailerCareType: memberSelectors.selectedTrailerCareType(state),
    shoppingCartMembershipType: memberSelectors.shoppingCartMembershipType(
      state
    ),
  }
}

const mapDispatchToProps = {
  autoCompleteAddress: apiActions.autoCompleteAddress,
  clearShoppingCart: memberActions.clearShoppingCart,
  createMembershipApplicationAccount:
    apiActions.createMembershipApplicationAccount,
  fetchPlaceDetails: apiActions.fetchPlaceDetails,
  lookupExistingContact: apiActions.lookupExistingContact,
  updateMembershipApplicationAccount:
    apiActions.updateMembershipApplicationAccount,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MemberContactInfo
)
